import { TABErrorType, useMROTabHandler } from "@cart-client/hooks/useMROTabHandler";
import { MROTab } from "@swiggy-private/cart-types";
import React from "react";

interface MROFoodCartContextValue {
    tabs: MROTab[];
    initTabComputeDone: boolean;
    handleTabSelect: (tab: MROTab) => void;
    handleBulkCartTabSelection: () => Promise<void>;
    tabError: TABErrorType | null;
    showFtue?: boolean;
}

export const MROFoodCartContext = React.createContext<MROFoodCartContextValue>({
    tabs: [],
    initTabComputeDone: false,
    handleTabSelect: () => void 0,
    handleBulkCartTabSelection: () => Promise.resolve(),
    tabError: null,
    showFtue: false,
});

export const MROFoodCartContextProvider = ({ children }: { children: React.ReactNode }) => {
    const { tabs, initTabComputeDone, handleTabSelect, handleBulkCartTabSelection, tabError, showFtue } =
        useMROTabHandler();
    return (
        <MROFoodCartContext.Provider
            value={{ tabs, initTabComputeDone, handleTabSelect, handleBulkCartTabSelection, tabError, showFtue }}
        >
            {children}
        </MROFoodCartContext.Provider>
    );
};
